export const ESTABLISHMENT_STATUS = {
  1: "Not Added",
  2: "Not Submitted",
  3: "Submitted"
};
export const ESTABLISHMENT_SIZE = {
  0: "No size selected",
  1: "Under 20 employees",
  2: "20-249 employees",
  21: "20-99 employees",
  22: "100-249 employees",
  3: "250+ employees"
};
export const ESTABLISHMENT_TYPE = {
  1: "",
  2: "State Government",
  3: "Local Government"
};
export const ESTABLISHMENT_STATE_RULES_ENUMERATION = {
  UNDER_20: 1,
  NON_GOVERNMENT: 1,
  STATE_GOVERNMENT: 2,
  LOCAL_GOVERNMENT: 3
};
export const ESTABLISHMENT_301_REQUIRED_ENUMERATION = {
  NOT_REQUIRED: 1,
  REQUIRED: 2,
  STATE_PLAN: 3,
  LEGACY: 4
};

export const ESTABLISHMENT_NOT_STARTED = 1;
export const ESTABLISHMENT_IN_PROGRESS = 2;
export const ESTABLISHMENT_SUBMITTED = 3;
export const SUMMARY_DATA_NOT_REQUIRED_MESSAGE = "The establishment with the provided NAICS code and the given size is not required to submit 300a summary data.";
export const ESTABLISHMENT_NOT_REQUIRED_TO_SUBMIT_301 = 0;
export const ESTABLISHMENT_REQUIRED_TO_SUBMIT_301 = 1;
export const ESTABLISHMENT_FROM_301_EXCLUDED_STATE = 2;
export const COMBINED_SUBMISSION_NOT_SUBMITTED = 0;
export const COMBINED_SUBMISSION_COMPLETED = 1;



/** WEBPACK FOOTER **
 ** ./src/constants/EstablishmentStatusEnumeration.js
 **/